import React from "react";
import { useQuickSightBedrock } from "@/hooks/useBedrockReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsBedrockDashboard from "@/components/organisms/BedrockDashboard";

function BedrockReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightBedrock();

  return (
    <AWSReportsTemplate
      title="AWS Bedrock Agents Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsBedrockDashboard />
    </AWSReportsTemplate>
  );
}

export default BedrockReports;
